<script lang="ts">
import { buildMeta } from "~~/utils/meta-builder";
export default defineComponent({
    setup() {
        useHead(buildMeta({ key:'imprint',  follow: false })) 
        const config = useRuntimeConfig()
				const emailConfig = config.public.email
        const email = `<a class="text-link hover:text-white" href="mailto:${emailConfig.other}">${emailConfig.other}</a>`
        const privacyEmail = `<a class="text-link hover:text-white" href="mailto:${emailConfig.privacy}">${emailConfig.privacy}</a>`
        return { email, privacyEmail}
    },
});

</script>
<template>
    <div class="bg-[#7E1EF8]">
        <Header theme="dark" />
        <div class="md:max-w-screen-md mx-auto text-white px-10 md:px-0">  
            <div class="text-white py-20">
                <h1 class="font-bold text-3xl md:text-4xl break-all font-owners">Legal Disclosure</h1>
                <p class="text-2xl py-4 font-light text-white/75">
                    Information in accordance with Section 5 TMG
                </p>
                <p class="py-10">Offlinefirst, LTD<br>Skoutari 25,<br>No. 2,<br>8560 Peyia, Cyprus</p>
                <h3 class="font-bold text-xl font-owners">Contact Information</h3>
                <br>E-Mail: info[@]offlinefirst.net
                <!-- <br>Internet address: <a href="https://www.offlinefirst.net" target="_blank">www.offlinefirst.net</a> -->
            </div>

            <h2 class="font-bold font-owners text-4xl py-10">Disclaimer</h2>    
            <div class="content-section" >
                <div class="content-sticky-section">
                  
                   <h3>Accountability for content</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">
                        The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents'
                        accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for 
                        our own content on these web pages. In this matter, please note that we are not obliged to monitor 
                        the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity. 
                        Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this as per 
                        §§ 8 to 10 of the Telemedia Act (TMG).  
                    </p>
                </div>
            </div>

           
            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3>Countability for links</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">
                        Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were 
                        evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective 
                        link immediately.
                    </p>
                </div>
            </div>

             <div class="content-section" >
                <div class="content-sticky-section">
                   <h3>Copyright</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">
                        Our web pages and their contents are subject to Cyprus copyright law. Unless 
                        expressly permitted by law, every form of utilizing, reproducing or processing 
                        works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. 
                        Individual reproductions of a work are only allowed for private use. 
                        The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.
                    </p>
                </div>
            </div>

          
            

         
        </div> 
        <div class="bg-white">
					<Footer />
				</div>
    </div>
</template>

